import { MessagesService } from 'app/layout/common/messages/messages.service';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NotificationsService } from 'app/layout/common/notifications/notifications.service';
import { QuickChatService } from 'app/layout/common/quick-chat/quick-chat.service';
import { ShortcutsService } from 'app/layout/common/shortcuts/shortcuts.service';
import { UserService } from './core/user/user.service';
import { forkJoin } from 'rxjs';
import { inject } from '@angular/core';
import { StorageService } from 'app/modules/auth/services/storage.service';
export const initialDataResolver = () => {
    const messagesService = inject(MessagesService);
    const navigationService = inject(NavigationService);
    const notificationsService = inject(NotificationsService);
    const quickChatService = inject(QuickChatService);
    const shortcutsService = inject(ShortcutsService);
    const userService = inject(UserService);
    const storageService = inject(StorageService);
    const clubId = storageService.getItem<string>('clubId');
    // Fork join multiple API endpoint calls to wait all of them to finish
    // if (!clubId) {
    //     console.error(" ERREUR : Aucun clubId trouvé dans le stockage local !");
    //     return forkJoin([
    //         navigationService.get(),
    //         messagesService.getAll(),
    //         notificationsService.getNotifications(),
    //         quickChatService.getChats(),
    //         shortcutsService.getAll(),
    //     ]);
    // }

    return forkJoin([
        navigationService.get(),
        messagesService.getAll(),
       // notificationsService.getNotifications(),
        quickChatService.getChats(),
        shortcutsService.getAll(),
        // userService.get(),
    ]);
};
